import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import getDocs from "../../../../../AdminAPI/DocsADM";
import fetchModel from "../../../../../AdminAPI/ModelADM";
import { getDocPlanADM } from "../../../../../AdminAPI/DocListPlanADM";
import NavBar from "../../../../Navbar/Navbar";
import { useTranslation } from "react-i18next";
import AdmAriane from "../../../../UtilsAdmin/AdmAriane";
import DocStat from "../../../../Dashboard/Default/LotStat/DocStats";
import Plan01Actions from "../../../../Dashboard/Default/TabDocs/Plan01Actions";
import DocsTableComponent from "../../../../Dashboard/Default/TabDocs/DocsTableComponent";
import AdminFullDocTableConfig from "../../AdminFullTableDocConfig.json";

const AdmTabDoc = () => {
  const [data, setData] = useState([]);
  const [modelName, setModelName] = useState("");
  const [modelInstanceStatuses, setModelInstanceStatuses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();

  const instanceId = Cookies.get("instanceId");
  const instanceName = Cookies.get("instanceName");
  const modelId = Cookies.get("modelId");
  const clientId = Cookies.get("clientId");
  const instanceStatus = Cookies.get("instanceStatus");
  const configkeyset = Cookies.get("configkey");

  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [filter, setFilter] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const idToken = Cookies.get("Token");
        const modelData = await fetchModel(clientId, idToken);
        const modelIdFromCookie = Cookies.get("modelId");

        const matchedModel = modelData.find((model) => model.ModelId === modelIdFromCookie);
        if (matchedModel) {
          const modelComponent = matchedModel.ModelComponent || matchedModel.ModelName;
          const modelNameFormatted = modelComponent.charAt(0).toUpperCase() + modelComponent.slice(1);
          setModelName(modelNameFormatted);
          setModelInstanceStatuses(matchedModel.ModelDocumentStatus || []);

          let responseData;
          if (modelNameFormatted === "Plan01") {
            responseData = await getDocPlanADM(idToken, instanceId, clientId);
          } else {
            responseData = await getDocs(instanceId, clientId, idToken);
          }
          setData(responseData);
        }
      } catch (error) {
        console.error("Erreur lors du chargement des données", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <>
      <NavBar />
      <div className="Ariane_LotStat_style">
        <AdmAriane
          mode="detailed"
          ModelName={modelName}
          instanceName={instanceName}
          instanceId={instanceId}
          handleCopy={(id) => console.log("Copié :", id)}
        />
        <DocStat
          lots={data}
          onFilterClick={(status) => {
            setFilter((prev) => {
              const newFilter = { ...prev, Status: status };
              return newFilter;
            });
          }}
        />
      </div>

      {modelName === "Plan01" && (
        <Plan01Actions
          data={data}
          filter={filter}
          instanceId={instanceId}
          modelId={modelId}
          selectedDocuments={selectedDocuments}
          setSelectedDocuments={setSelectedDocuments}
          configkeyset={configkeyset}
          instanceStatus={instanceStatus}
          t={t}
          isInstanceEditable={(status) => !["completed", "production"].includes(status)}
        />
      )}

      <DocsTableComponent
        data={data}
        setData={setData}
        modelName={modelName}
        modelId={modelId}
        clientId={clientId}
        instanceId={instanceId}
        modelInstanceStatuses={modelInstanceStatuses}
        page="AdmTabDoc"
        tableConfig={AdminFullDocTableConfig}
        selectedDocuments={selectedDocuments}
        setSelectedDocuments={setSelectedDocuments}
        filter={filter}
        setFilter={setFilter}
      />
    </>
  );
};

export default AdmTabDoc;
